import { z } from "zod";

export const OrganizationCloseStagePathParamsSchema = z.object({
    organizationId: z.string().uuid(),
});

export const CloseStagePathParamsSchema = z.object({
    closeStageId: z.string().uuid(),
});

export const OrganizationCloseStageCreateSchema = z.object({
    name: z.string().trim().min(1, { message: "Required" }).max(255),
    parentCloseStageId: z.string().uuid().nullable().optional(),
});

export type OrganizationCloseStageCreate = z.infer<
    typeof OrganizationCloseStageCreateSchema
>;

export const OrganizationCloseStageUpdateSchema = z.object({
    name: z.string().trim().min(1).max(255),
});

export type OrganizationCloseStageUpdate = z.infer<
    typeof OrganizationCloseStageUpdateSchema
>;

export const OrganizationCloseStageChangePositionSchema = z.object({
    parentCloseStageId: z.string().uuid().nullable(),
    order: z.number().int().nonnegative(),
});

export type OrganizationCloseStageChangePosition = z.infer<
    typeof OrganizationCloseStageChangePositionSchema
>;
